import References from './Reference';
import AuthService from './auth'
import { useStationFilter } from '../components/SearchStation/store';
import L from 'leaflet';

import dayjs from 'dayjs';

export const round = (value, precision) => {
    if (!isNaN(value) && !isNaN(parseFloat(value)))
        return value.toFixed( precision );
};


export const sprintf = (format, ...args) => {
    let i = 0;
    return format.replace(/%s/g, () => args[i++]);
}

export function parseActual( data, onFinish ) {
    let markers = [];

    for (let i in data ) {

/*        if (data[i].short_name !== "250" && data[i].short_name !== "37")            
            continue;*/

        markers.push({
            uuid: i,
            lat: data[i].lat,
            lon: data[i].lon,
            name: data[i].name,
            short_name: data[i].short_name,
            state: data[i].state,
            complexes: [],//getComplexes( data[i] ),
            mchs_groups: data[i]?.mch_groups,
            mchs: getMchs( data[i] ),
            photo: getPhoto( data[i] ),
            area: data[i].area,
            district: data[i].district,
            holder_uuid: data[i]?.holder_uuid,
            holder_name: data[i]?.holder_name,
            city: data[i].city,
            locality: data[i].locality,
            monitoring_object: data[i].monitoring_object,
        });
    }    
    return markers;
}

export function loadActual( loaded ) {
    if (loaded) return;
    return AuthService.fetch(References.api.actual)
        .then(res => res.json())
        .catch(() => console.log('need auth'));
}

export function loadMeasurers( uuid, type, channelType, start, finish, settings, normalizeMethod ) {
    const baseUrl = normalizeMethod !== 'no' && References.normalizes_methods.hasOwnProperty(normalizeMethod) ?
        References.api.data_normalization :
        References.api.data
    let url = sprintf(
        baseUrl,
        type,
        channelType,
        uuid,
        encodeURIComponent(dayjs(start, References.dateTimeFormat).format()),
        encodeURIComponent(dayjs(finish, References.dateTimeFormat).format()),
        normalizeMethod
    );
    for (let i in settings) {
        if (settings[i] && settings[i].length > 0) 
            url += `&${i}=${settings[i]}`;
    }
    return AuthService.fetch(url)
    .then(res => res.json());
}

export function loadGroupMeasurers(station, uuid, start, finish) {

    const measurers = station.mchs.filter(val => val.group_id === uuid );
    const urls = measurers.map(val => sprintf(
        References.api.data,
        'mchs',
        val.type,
        val.uuid,
        encodeURIComponent(dayjs(start, References.dateTimeFormat).format()),
        encodeURIComponent(dayjs(finish, References.dateTimeFormat).format())
    ));

/*    const result = new Array();
    measurers.map(val => {
        loadMeasurers(val.uuid, 'mchs', val.type, start, finish)
            .then((data) => {
                result.push(prepareMeasurers(data, val.uuid, 'mchs', val.type, null, null, val.settings))
            })
    })*/
    return AuthService.fetchAll(urls)
    .then(responses => Promise.all(responses.map(r => r.json())))
/*    console.log( responses );
    return Promise.all(responses.map(response => response.json()));

    const url = sprintf(
        References.api.group,
        uuid, 
        encodeURIComponent(dayjs(start, References.dateTimeFormat).format()),
        encodeURIComponent(dayjs(finish, References.dateTimeFormat).format()),
    );*/
}

export function loadAnalytics( uuid, type, start, finish, period) {

    if (period === '12H') {
        start = dayjs(start, References.dateTimeFormat).add(6, 'hour').format();
        finish = dayjs(finish, References.dateTimeFormat).add(6, 'hour').format();
    } else {
        start = dayjs(start, References.dateTimeFormat).format();
        finish = dayjs(finish, References.dateTimeFormat).add(86399, 'second').format();
    }

    let url = sprintf(
        References.api.analytic,
        type,
        uuid,
        encodeURIComponent( start ),
        encodeURIComponent( finish ),
        period        
    );
    return AuthService.fetch(url)
    .then(res => res.json());
}

export function parseAnalytics( type, data ) {
    let result = [];  
    if (References.mchs.hasOwnProperty(type) && References.mchs[type].hasOwnProperty('analytic')) {

        let mchs = References.mchs[type];
        let fields = mchs.analytic;
        let tooltip = fields?.tooltip;
        let key = Object.keys( data );

        let precision = !isNaN(fields?.precision) ? fields.precision : mchs.precision;        

        if (key.length > 0) {
            let values = data[key[0]].values;
            result = values.map( data => {
                let low = data.hasOwnProperty(fields.low) ? data[fields.low]?.toFixed(precision) : Number(fields.low).toFixed(precision);
                let high = data.hasOwnProperty(fields.high) ? data[fields.high]?.toFixed(precision) : Number(fields.high).toFixed(precision);
                let avg = data.hasOwnProperty(fields.avg) ? data[fields.avg]?.toFixed(precision) : Number(fields.avg).toFixed(precision);
                let sum = data.hasOwnProperty(fields.sum) ? data[fields.sum]?.toFixed(precision) : Number(fields.sum).toFixed(precision);

                const t = new Intl.NumberFormat(References.locale).format(111111);

                let value = {
                    'o': high,
                    'c': low,
                    'h': high,
                    'l': low,
                    'a': avg,
                    'sum': sum,
                    'x': data.time,
                    'high': high,
                    'low': low,
                    'avg': avg,
                    'datasets': fields?.datasets
                }   
                if (tooltip) {                 
                    value.t = `${tooltip.text}: ${data[tooltip.field] ? data[tooltip.field].toFixed(precision) : null}`;  
                }

                value.max = Math.max( high, low );
                value.min = Math.min( high, low );
                return value;
            })
        }     
    }
    return result;
}

export function loadGEO( type ) {
    let url = sprintf(
        References.api.geo,
        type
    );
    let geo = AuthService.fetch(url)
        .then( res => res.json());
    return geo;
}

export function loadAKB() {
    let url = sprintf(References.api.akb);
    return AuthService.fetch(url)
    .then(res => res.json());
}

export function parseAKB( data ) {
    let akb = [];
    for (let i in data)  {
        for (let v12 in data[i].voltage12) {
            let voltage12 = {
                uuid: v12,
                state: data[i].voltage12[v12].state,
                last_value: data[i].voltage12[v12].last_value,
                night_value: data[i].voltage12[v12].night_value,
                power: data[i].voltage12[v12].power
            }
            data[i].voltage12 = voltage12;
        }

        for (let v4 in data[i].voltage4) {
            let voltage4 = {
                uuid: v4,
                state: data[i].voltage4[v4].state,
                last_value: data[i].voltage4[v4].last_value,
                night_value: data[i].voltage4[v4].night_value,
                power: data[i].voltage4[v4].power                
            }
            data[i].voltage4 = voltage4;
        }

        //время выхода на связь
        if (data[i].hasOwnProperty('online')) {
            let key = Object.keys(data[i].online);
            if (key.length > 0)
                data[i].online = data[i].online[key[0]].last_value;
        }

        //тех. состояние
        if (data[i].hasOwnProperty('tech')) {
            let key = Object.keys(data[i].tech);
            if (key.length > 0) { 
                data[i].tech = data[i].tech[key[0]].last_value;
                data[i].tech.uuid = key[0];
            }
        }

        //фото
        if (data[i].hasOwnProperty('photo')) {
            let key = Object.keys( data[i].photo );
            if (key.length > 0) {                             
                key = key[0];
                data[i].photo ={
                    last_value: data[i].photo[key].last_value,
                    status: data[i].photo[key].state,
                    uuid: key
                };
            }
        }
        akb.push(data[i]);
    }    

    return akb;
}

export function loadDetailAKB( type, uuid, start, finish ) {

    let url = sprintf(
        References.api.detail_akb,
        type,
        uuid,
        encodeURIComponent(dayjs(start, References.dateTimeFormat).format()),
        encodeURIComponent(dayjs(finish, References.dateTimeFormat).format())
    );
    return AuthService.fetch(url).then(res => res.json());
}

export function loadDetailAKB_Soc( type, uuid, start, finish ) {
    let url = sprintf(
        References.api.detail_akb,
        type,
        uuid,
        encodeURIComponent(dayjs(start, References.dateTimeFormat).format()),
        encodeURIComponent(dayjs(finish, References.dateTimeFormat).format())

    ) + '&fields=soc';
    return AuthService.fetch(url).then(res => res.json());         
}

export function loadDetailAKB_Power( type, uuid, start, finish ) {
    let url = sprintf(
        References.api.detail_akb,
        type,
        uuid,
        encodeURIComponent(dayjs(start, References.dateTimeFormat).format()),
        encodeURIComponent(dayjs(finish, References.dateTimeFormat).format())

    ) + '&fields=power_delta';
    return AuthService.fetch(url).then(res => res.json());         
}

export function loadDetail_Signal( uuid, start, finish ) {
    let url = sprintf(
        References.api.detail_station,
        uuid,
        encodeURIComponent(dayjs(start, References.dateTimeFormat).format()),
        encodeURIComponent(dayjs(finish, References.dateTimeFormat).format())
    ) + '&fields=operator,rssi,rsrp,rssnr';
    return AuthService.fetch(url).then(res => res.json());         
}

export function loadPrecTriangle( date ) {
    let url = sprintf(
        References.api.prec_triangle,
        dayjs(date, References.dateFormat).toISOString(),            
    );
    return AuthService.fetch(url).then(res => res.json());         
}

export function showPrecTriangle( map, data ) {
    let lgrid_params = data["params"]
    let lstart_lan = data["params"]["start_lan"]    // Начало сетки (широта)
    let lstart_lon = data["params"]["start_lon"]    // Начало сетки (долгота)
    let lstep_lan = data["params"]["step_lan"]      // Шаг сетки (широта)
    let lstep_lon = data["params"]["step_lon"]      // Шаг сетки (долгота)
    let rectangles = new Array();

    // Перебираем массив данных по датам (для отображения - будет 1 дата, по идее)
    for (var key in data["data"]) 
    {
        let dlprec = data["data"][key]

        // Перебираем строки в массиве с осадками
        let rstlan = lstart_lan // начальная широта
        let rstlon = lstart_lon // начальная долгота
        for (let ir = 0; ir < dlprec.length; ir++)
        {
            let irow = dlprec[ir]                           // Строка с данными триангуляции
            let c_start_lan = rstlan - (lstep_lan * ir)     // Задаем широту начала ячейки для строки
            let c_end_lan = rstlan - (lstep_lan * (ir +1))  // Задаем широту конца ячейки для строки
            for (let ic = 0; ic < irow.length; ic++)
            {
                let cell_prec = irow[ic]                        // Ячейка с данными триангуляции
                let c_start_lon = rstlon + lstep_lon * ic       // Задаем долготу начала ячейки
                let c_end_lon = rstlon + lstep_lon * (ic + 1)   // Задаем долготу начала ячейки

                // Формируем ячейку для карты
                let corners = [[c_start_lan, c_start_lon], [c_end_lan, c_end_lon]]; // Углы прямоугольника-ячейки
                let rectangle = L.rectangle(corners);               // Непосредственно ячейка карты

                let prec_mm = parseFloat((cell_prec).toFixed(1));   // Округляем осадки до двух знаков
                rectangle.popup = ("P: " + prec_mm);                                

                let grid_cell_fill_opacity = 0.0;       // Значение прозрачности ячейки
                let grid_cell_fill_color = "#0000FF";   // Базовый цвет ячейки

                if (prec_mm <= 0.0)
                {
                    // Для нулевых осадков - полностью прозрачно
                    grid_cell_fill_opacity = 0.0;
                    grid_cell_fill_color = "#000000";
                }
                else if (prec_mm >= 20.0)
                {
                    // Для осадков больше 20 мм/10мин - полностью заретушировано и цвет поярче
                    grid_cell_fill_opacity = 1.0;
                    grid_cell_fill_color = "#000080";
                }
                else
                {
                    // Тут считаем всякие промежуточные значения прозрачности
                    let prec_op_by_sot = Math.round(prec_mm * 100);
                    let prec_op_by_two_sot = Math.round(prec_op_by_sot / 2);
                    let prec_result_op = prec_op_by_two_sot / 100.0;
                    grid_cell_fill_opacity = prec_result_op;
                    grid_cell_fill_color = "#0000FF";
                }

                rectangle.setStyle({fillColor: grid_cell_fill_color, fillOpacity:grid_cell_fill_opacity, weight:0});    // Подвязываем стиль
                rectangle.key = ir +'_'+ ic;
                rectangles.push( rectangle );                
            }
        }
    }
    return rectangles;
}

const getSignalMode = ( data ) => {
    for (let i in data) {
        if (data[i]?.system_mode === 1)
            return 'LTE';
        if (data[i]?.system_mode === 0)
            return 'GSM';
    }
}

export function parseDetailSignal( data ) {

    const signalPattern = () => {
        return {
            "values": [],                
            "states": []
        }
    }

    let keys = Object.keys( data );
    if ( keys.length === 0) 
        return false;

    let values = data[keys[0]].values;        
    let systemMode = getSignalMode( values );

    if (!systemMode)        
        return false;

    let result = {
        "labels": new Array(),
        "signal": new Array(),
        "operator": new Array()
    };

    for ( let i in values ) {            
        let val = values[i];

        result.labels.push( ShowLocaleDateTime(val.time) );
        result.operator.push(val.operator);            

        //lte
        if (systemMode === 'LTE') {
            if (result.signal.length === 0) {
                result.signal[0] = signalPattern();
                result.signal[1] = signalPattern();
            }                    
            result.signal[0].values.push(val.rsrp);
            result.signal[0].states.push(val.rsrp_state);
            result.signal[1].values.push(val.rssnr);
            result.signal[1].states.push(val.rssnr_state);
        } else {
            if (result.signal.length == 0) 
                result.signal[0] = signalPattern();

            result.signal[0].values.push(val.rssi);
            result.signal[0].states.push(val.rssi_state);
        }

    }
    return result;
}

export function parseDetailAKB( data, type, neededField ) {
    let result = {
        "labels":   [],
        "data":     []
    };
    let ref = References.sensors[type];
    let field = neededField ? neededField : type;

    let keys = Object.keys(data);
    if (keys.length > 0) {
        let values = data[keys[0]].values;
        for (let i in values) {
            let val = values[i];

            result['labels'].push( new Date(val.time).toLocaleDateString(
                References.locale, {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'}
            ) );

            result['data'].push( round(val[field], ref.precision) );
        }
    }
    return result;
}

export function loadEvent( props ) {
    let url = sprintf(
        References.event.url,
        encodeURIComponent(dayjs(props?.start, References.dateTimeFormat).format()),
        encodeURIComponent(dayjs(props?.finish, References.dateTimeFormat).format())
    );

    if (props?.selectedDangers?.length > 0)
        url += `&danger_level_code=${props.selectedDangers.join(',')}`;

    if (props?.selectedMchsTypes?.length > 0) {
        //некоторые измерители могут быть сгруппированы - надо достать все каналы группы
        let mchsTypes = [];
        props.selectedMchsTypes.forEach(item => {
            const foundGroup = findEventGrouped(item);
            if (foundGroup) {
                mchsTypes = mchsTypes.concat(foundGroup.mchs);
            }
            else
                mchsTypes.push(item);
        });
        url += `&mch_type=${mchsTypes.join(',')}`;        
    }

    if (props?.stationValue?.length > 0)
        url += `&station=${props.stationValue}`;            

    if (props?.filterNODATA)
        url += `&enabled_no_data=1`;

    if  (isFinite(props?.filterEscalade))
        url += `&direction=${props.filterEscalade}`;

    return AuthService.fetch(url)
    .then(res => res.json());    
}

export function getStateInfo( state, mchsType, field ) {
    if ( References.states.hasOwnProperty( state ) )  
        return field ? References.states[state][field] : References.states[state]
    if ( References.states.hasOwnProperty(mchsType) && References.states[mchsType].hasOwnProperty( state) )
        return field ? References.states[mchsType][state][field] : References.states[mchsType][state];
    return field ? References.states['default'][field] : References.states['default'];
}

export function getDangerLevelInfo( dangerLevel, field ) {
    if (References.danger.hasOwnProperty(dangerLevel)) {
        return field ? References.danger[dangerLevel][field] : References.danger[dangerLevel];

    }
    return field ? References.danger['default'][field] : References.danger['default'];
}

export function getDangersList() {
    let result = [];
    for (let i in References.danger) {
        let danger = References.danger[i];
        if (i == 'default')
            continue;
        result.push({
            'code': i,
            'short': danger.short,
            'title': danger.title,
            'color': danger.color,
        });
    }
    return result;
}

export function getMchsList(stations) {

    //формируем набор каналов из слоя актуальности
    const allMchs = fillMCHS(stations); 

    //список уже ранее добавленных групп, некоторые каналы нужно сгруппировать
    let groupsAdded = [];

    let result = [];
    if (allMchs) {
        allMchs.forEach((item) => {
            //канал существует в списке используемых каналов
            if (References.mchs[item]) {
                const mchs = {
                    code: "",
                    name: ""
                }            
                //поиск в группах
                const foundGroup = findEventGrouped(item);
                if (foundGroup) {
                    if (!groupsAdded.includes(foundGroup.code)) {
                        //группа существует, остальные каналы из этой группы добавлять не надо
                        groupsAdded.push(foundGroup.code);
                        mchs.code = foundGroup.code;
                        mchs.name = foundGroup.name;
                        result.push(mchs);                    
                    }
                } else {
                    mchs.code = item;
                    mchs.name = References.mchs[item].name
                    result.push(mchs);                    
                }
                
            }
        })        
    }    
    return result;
}

function findEventGrouped(mchs) {
    let group = {}
    References.event.groups.some(item => {
        if (item.mchs.includes(mchs)) {
            group = item;
            return true;
        }
    });    
    if (group?.code)
        return group;
}

export function getChartType( chartTypes ) {
    if (typeof chartTypes == 'object') {
        let keys = Object.keys(chartTypes[0]);
        return keys[0];
    }
    else 
        return chartTypes;            

}


function getComplexes( station ) {
    let complexes = [];
    for (let c in station.dataloggers)
    {
        let complex = station.dataloggers[c];

        //серсоры комплекса
        let sensors = [];
        for (let s in complex.sensors) {

            //типы сенсоров
            for (let t in complex.sensors[s]) {
                if (!References.sensors.hasOwnProperty(s))
                    continue;

                let logger = References.sensors[s];
                let last = {
                    stateCode: null,
                    stateTime: null,
                    value: null,
                    time: null,
                    unit: null
                };

                if (complex.sensors[s][t].hasOwnProperty('state')) {
                    last.stateCode = complex.sensors[s][t].state.state_code;
                    last.stateTime = complex.sensors[s][t].state.state_time;
                    last.value = round(complex.sensors[s][t].state.last_value[logger['field']], logger['precision']);
                    last.unit = logger.unit;
                }

                sensors.push({
                    uuid: t,
                    type: s,
                    name: logger['name'],
                    last_value:  last

                });
            }
        }
        complexes.push({
            'uuid': c,
            'name': complex.name,
            'sn': complex.sn,
            'sensors': sensors
        });
    }
    return complexes;
}

function getMchs( station ) {
    let result = [];
    let mchsList = station.mchs;
    let mchsPriors = Object.keys(References.mchs);

    for ( let type in mchsList ) {

        if (!References.mchs.hasOwnProperty(type))
            continue;
        let logger = References.mchs[type];
        let currGroup = null;

        let mchs = mchsList[type];
        for (let uuid in mchs) {
            const mch = mchs[uuid];
            const hasState = mch.hasOwnProperty('state');
            const hasLast = hasState && mch.state.hasOwnProperty('last_value');
            const hasSettings = mch.hasOwnProperty('settings');
            const not_configured = !hasState || mch.state.state_code == References.no_data_code;
            const hasHDI = type === 'waterlevel' && hasLast && mch.state.last_value.hasOwnProperty('hdi_ihr');

            let extInfo = null;            
            if (hasLast && logger.hasOwnProperty('extInfo')) 
                extInfo = `(${logger.extInfoCalc(mch.state.last_value[logger.extInfoField])}${logger?.extInfoUnit || ''})`;

            //иногда нужно приенять функию, чтобы понять, какое поле показывать из набора данных
            const field =  typeof logger.field === 'function' ? logger.field(mch?.settings, type) : logger.field;            
            //является ли измерителем элементом группы
            const isGroup = station?.mch_groups?.hasOwnProperty(mch?.group) ? true : false;
            const isStartGroup = isGroup && mch.group != currGroup;
            if (isGroup) {                
                currGroup = mch.group;
            }

            result.push({
                type: type,
                typeName: mchs[uuid].name,
                chartType: logger?.tabs ? "chart_tab" : logger.chart_type,
                tabs: logger?.tabs,
                uuid: uuid,
                level_code: hasState ? mchs[uuid].state.level_code : null,
                state_code: hasState ? mchs[uuid].state.state_code : null,
                settings: hasSettings ? mchs[uuid].settings : null,
                is_in_group: isGroup,
                is_first_in_group: isGroup ? isStartGroup : false,
                group_id: isGroup ? mch?.group : null,                
                group_name: isGroup ? station?.mch_groups[mch?.group].name : null,
                main: mch?.mch_main,
                state_time: hasLast ? mchs[uuid].state.last_value.time : null,
                value: hasLast ? round(mchs[uuid].state.last_value[field], logger.precision) : null,
                unit: logger.unit,
                extInfo: extInfo,
                tooltips: logger.tooltips,
                mchs: mchs[uuid],
                prior: mchsPriors.indexOf(type),
                not_configured: not_configured ? 1 : 0,
                has_hdi: hasHDI ? 1 : 0
            })
        }
    }

    if (result.length > 1)
        result.sort(( a, b ) => a.prior - b.prior );

    //некоторые каналы могут быть сгруппированы - формируем из них группу
    //result = groupMCHS( result );
    return result;
}

function groupMCHS( mchs ) {
    let currentGroup = null;
    let result = new Array();

    for (let i in mchs) {
        const mch = mchs[i];
        if (!mch.is_in_group) {
            result.push(mch);
            continue;
        }
       
        //элемент группы
        if (currentGroup !== mch.group_id) {
            //группа еще не создана - формируем элемент
            currentGroup = mch.group_id;
            result.push({
                uuid: mch.group_id,
                group_name: mch.group_name,
                type: mch.type,
                typeName: mch.group_name,
                is_group: true,
                group: new Array()
            });
        }
        result[result.length - 1].group.push(mch);       
    }
    return result;
}

export const getSolidHumidityField = (settings, type) => {
    return settings?.display_value_in_percent ? References.mchs[type].field_percent : References.mchs[type].field_common;
}

export const fillMCHS = ( stations ) => {
    let allMCHS = new Array();
    stations.forEach(station => {
        station?.mchs.forEach(mchs => {
            if (allMCHS.indexOf(mchs?.type) === -1)
                allMCHS.push( mchs?.type)
        })
        //photo
        if (station?.photo) {
            if (allMCHS.indexOf('photo') === -1)
                allMCHS.push('photo');
        }
    });
    return allMCHS;
}


export const getMeasurers = (data, uuid, channel, type, settings, mchSettings ) => {
    let result = {
        "labels":   [],
        "data":     [],
        "source": []
    };

    try {

        if (!data.hasOwnProperty(uuid))
            throw new Error('invalid uuid');

        if (!References.hasOwnProperty(channel) || !References[channel].hasOwnProperty(type))
            throw new Error('Invalid type or channel');

        const ref = References[channel][type];

        //может показываться, как альтернативное поле, так и вычисляемое, если ref.field - функция
        const field = 
            settings?.alt_field 
                ? 
                    settings.alt_field : 
                    typeof ref.field === 'function' 
                        ? 
                            ref.field(mchSettings, type) : ref.field;        
        ;
        const measurers = data[uuid].values;

        const isNormalized = data[uuid].hasOwnProperty('values_norm');
        const measurersNorm = data[uuid]?.values_norm;

        if (isNormalized) {
            result.data_norm = [];
            result.source_norm = []
        }

        for (let i in measurers) {

            result['labels'].push(ShowLocaleDateTime(new Date(measurers[i].time)));
            //отметки по оис X
            result['data'].push(measurers[i][field] == null ? null : Number(round( measurers[i][field], ref.precision)) );
            //исходные данные
            result['source'].push( measurers[i] );

            //нормализованные данные (если есть)
            if (isNormalized) {
                result['data_norm'].push(measurersNorm[i][field] == null ? null : Number(round(measurersNorm[i][field], ref.precision)) );
                result['source_norm'].push( measurersNorm[i] );                

            }
        }

        //дополняем добавленными/удаленными при нормализации
        if (isNormalized) {
            result['data_add'] = data[uuid].values_add.map(val => {
                return {
                    time: ShowLocaleDateTime(new Date(val.time)),
                    value: Number(round(val[ref.field], ref.precision))
                }
            });
            result['data_del'] = data[uuid].values_del.map(val => {
                return {
                    time: ShowLocaleDateTime(new Date(val.time)),
                    value: Number(round(val[ref.field], ref.precision))
                }
            })

        }

    }
    catch ( e ) {
        console.log(e.message);
        return result;
    }
    return result;

}

export const getMeasurersTabs = (data, tabs) => {
    const keys = Object.keys(data);
    if (keys.length === 0)
        throw new Error('no_data');
    const values = data[keys]?.values;
    if (values.length === 0)
        throw new Error('no_data');

    let result = [].fill(tabs.length);

    values.forEach(val => {
        tabs.forEach((tab, idx) => {            
            if (!result.hasOwnProperty(idx)) {
                result[idx] = {
                    labels: [],
                    data: [],
                    source: []
                }
            }
            result[idx].labels.push(ShowLocaleDateTime(new Date(val.time)));
            result[idx].data.push(val[tab?.source]);            
            result[idx].source.push(val);
        })
    })      
    return result;
}

export const prepareMeasurers = (data, uuid, channel, type, chartType, settings, mchSettings) => {
    //несколькол вкладок с графиками, либо график с несколькими источниками данных
    if (chartType === 'chart_tab')
        return getMeasurersCommon(data, uuid, channel, type, settings, mchSettings );

    return getMeasurers(data, uuid, channel, type, settings, mchSettings);
}

export const prepareGroupMeasurers = (data, type, mchSettings) => {
    return data.map(val => {
        try { 
            const uuid = Object.keys(val)[0];
            return getMeasurers(val, uuid, 'mchs', type, null, mchSettings)
        } catch (e) {
            console.log(e.message);
        }
    });
}

export const getMeasurersCommon = (data, uuid, channel, type, settings ) => {

    let tabDatasets = new Array();

    try {

        if (!data.hasOwnProperty(uuid))
            throw new Error('invalid uuid');

        if (!References.hasOwnProperty(channel) || !References[channel].hasOwnProperty(type))
            throw new Error('Invalid type or channel');
   
        const ref = References[channel][type];
        const field = settings?.alt_field ? settings.alt_field : ref.field;        
        const measurers = data[uuid].values;

        //если для канала одна вкладка, формируем
        const tabs = ref?.tabs ? ref.tabs : [createEmptyTab(ref, field)];        

        for (let i in measurers) {
            const val = measurers[i];
            
            tabs.forEach((tab, tabIdx) => {

                if (!tabDatasets.hasOwnProperty(tabIdx)) {
                    tabDatasets[tabIdx] = {
                        "labels": new Array(),
                        "sources": new Array(),
                        "data": new Array()
                    }
                }

                tabDatasets[tabIdx].labels.push(ShowLocaleDateTime(new Date(val.time)));
                tabDatasets[tabIdx].sources = val;

                tab.source.forEach((src, srcIdx) => {

                    if (!tabDatasets[tabIdx].data.hasOwnProperty(srcIdx))
                        tabDatasets[tabIdx].data[srcIdx] = new Array();                       
                    tabDatasets[tabIdx].data[srcIdx].push(val.hasOwnProperty(src) ? Number(round( val[src], tab.precision)) : null)

                })


            })

        }
      
    }
    catch ( e ) {
        console.log(e.message);
        return tabDatasets;
    }
    return tabDatasets;

}

const createEmptyTab = (ref, field) => {
    return  {
        "title": ref.name,
        "source": [field],
        "precision": ref.precision,
        "unit": ref.unit
    }
}

const getPhoto = ( station ) => {
    if (station.mchs.hasOwnProperty('photo')) {
        let keys = Object.keys(station.mchs.photo);
        let photo = station.mchs.photo[keys[0]];
        if (photo.hasOwnProperty('state'))
            return {
                "uuid": keys[0],
                "name": photo.name,
                "state": photo.state?.state_code,
                "time": photo.state?.last_value?.time,
                "photo_id": photo.state?.last_value?.id
            };
    }
}

export const loadPhoto = ( photo ) => {
    let url = sprintf( References.api.get_photo, photo.uuid, photo.photo_id)
    return AuthService.fetch(url).then(res => res.json());         
}

export const loadPhotos = ( photo, start, finish ) => { 
    let url = sprintf( 
        References.api.get_photos, 
        photo.uuid, 
        encodeURIComponent(dayjs(start, References.dateTimeFormat).format()),        
        encodeURIComponent(dayjs(finish, References.dateTimeFormat).format())
    );
    return AuthService.fetch(url).then(res => res.json());         
}

export const parsePhotos = ( photos ) => {
    let keys = Object.keys( photos );
    if ( keys.length > 0) {
        photos = photos[keys[0]];
        return photos.values.reverse();
    }
}

export const searchInJSONArray = ( arr, key, search ) => {
    return arr.filter( (val) => val[key] === search ).length > 0;
}

export const findInJSONArray = (arr, key, search ) => {
    let result = arr.filter( (val) => val[key] === search );
    return result.length > 0 ? result[0] : [];
}

export const findIndexInJSONArray = (arr, key, search ) => {
    let index = -1;
    arr.forEach((val, idx) => {
        if (val[key] === search)         
            index = idx;
    })    
    return index;
}

export const removeFromJSONArray = ( arr, key, removed ) => {
    return arr.filter( (val) => val[key] !== removed);
}

export function getMaxFromJSONArray( arr, key ) {
    let result = 0;
    for ( let i in arr) {
        if (result <= arr[i][key])
            result = arr[i][key] + 1;
    }
    return result;
}

export const objectKey = ( obj ) => {
    let key = Object.keys( obj );
    return key[0];
}

export const objectValue = ( obj ) => {
    let key = Object.keys( obj );
    return obj[ key ];

}

export const CopyText = ( text ) => {

    let inpt = document.createElement("input");
    inpt.value = text;
    document.body.appendChild(inpt);
    inpt.select();
    document.execCommand("copy");
    document.body.removeChild(inpt);

    alert('Скопировано: ' + text);
}

export const forecastPics = {
    //дождь
    '60': '<svg id="Layer_1" enable-background="new 0 0 90 90" viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg"><g fill="rgb(0,0,0)"><path d="m30.83 61.53c-.29 0-.58-.07-.85-.19-.98-.48-1.4-1.65-.94-2.64l2.65-5.59c.61-.92 1.85-1.17 2.77-.56.74.49 1.07 1.41.81 2.25l-2.65 5.6c-.33.68-1.03 1.12-1.79 1.13z"/><path d="m24.73 74.41c-.29 0-.58-.06-.84-.19-.98-.47-1.4-1.64-.95-2.63l2.65-5.6c.33-1.05 1.46-1.64 2.51-1.3 1.05.33 1.64 1.46 1.3 2.51-.05.17-.13.34-.23.49l-2.67 5.59c-.33.68-1.01 1.11-1.77 1.13z"/><path d="m43.29 61.53c-.29 0-.58-.07-.85-.19-.98-.48-1.4-1.65-.94-2.64l2.65-5.59c.61-.92 1.85-1.17 2.77-.56.74.49 1.07 1.41.81 2.25l-2.65 5.6c-.33.68-1.03 1.12-1.79 1.13z"/><path d="m37.19 74.41c-.29 0-.58-.06-.84-.19-1-.45-1.44-1.63-1-2.63l2.65-5.6c.33-1.05 1.46-1.64 2.51-1.3 1.05.33 1.64 1.46 1.3 2.51-.05.17-.13.34-.23.49l-2.65 5.59c-.32.67-.99 1.1-1.74 1.13z"/><path d="m55.75 61.53c-.29 0-.58-.07-.85-.19-.98-.48-1.4-1.65-.94-2.64l2.65-5.59c.61-.92 1.85-1.17 2.77-.56.74.49 1.07 1.41.81 2.25l-2.69 5.6c-.33.67-1 1.11-1.75 1.13z"/><path d="m49.65 74.41c-.29 0-.58-.06-.84-.19-.98-.47-1.4-1.64-.95-2.63l2.64-5.59c.33-1.05 1.46-1.64 2.51-1.3 1.05.33 1.64 1.46 1.3 2.51-.05.17-.13.34-.23.49l-2.65 5.59c-.33.68-1.02 1.11-1.78 1.12z"/><path d="m65.89 55.85c-1.1 0-2-.9-2-2s.9-2 2-2c4.48-.03 8.09-3.68 8.06-8.16-.02-3.95-2.89-7.3-6.78-7.95-.52-.08-.99-.37-1.3-.8s-.44-.97-.35-1.49c.88-4.89-2.38-9.57-7.27-10.45-.54-.1-1.09-.14-1.64-.14-1.94 0-3.83.63-5.39 1.79-.85.62-2.03.48-2.71-.33-4.61-5.62-12.91-6.43-18.54-1.82-2.91 2.39-4.66 5.9-4.8 9.66-.05.94-.74 1.71-1.66 1.87-4.87.97-8.03 5.72-7.06 10.59.82 4.09 4.35 7.09 8.52 7.23 1.1 0 2 .9 2 2s-.9 2-2 2c-7.14 0-12.93-5.79-12.93-12.93 0-5.74 3.79-10.8 9.3-12.41 1.22-9.38 9.82-16 19.2-14.78 3.7.48 7.14 2.16 9.8 4.78 1.91-1.05 4.05-1.61 6.23-1.6 7.18 0 13 5.82 13 13v.35c6.34 2.06 9.81 8.87 7.75 15.21-1.61 4.97-6.25 8.34-11.47 8.34z"/></g></svg>',
    //ледяной дождь
    '67': '<svg id="Layer_1" enable-background="new 0 0 90 90" viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg"><g fill="rgb(0,0,0)"><path d="m30.83 61.53c-.29 0-.58-.07-.85-.19-.98-.48-1.4-1.65-.94-2.64l2.65-5.59c.61-.92 1.85-1.17 2.77-.56.74.49 1.07 1.41.81 2.25l-2.65 5.6c-.33.68-1.03 1.12-1.79 1.13z"/><path d="m24.73 74.41c-.29 0-.58-.06-.84-.19-.98-.47-1.4-1.64-.95-2.63l2.65-5.6c.33-1.05 1.46-1.64 2.51-1.3 1.05.33 1.64 1.46 1.3 2.51-.05.17-.13.34-.23.49l-2.67 5.59c-.33.68-1.01 1.11-1.77 1.13z"/><path d="m43.29 61.53c-.29 0-.58-.07-.85-.19-.98-.48-1.4-1.65-.94-2.64l2.65-5.59c.61-.92 1.85-1.17 2.77-.56.74.49 1.07 1.41.81 2.25l-2.65 5.6c-.33.68-1.03 1.12-1.79 1.13z"/><path d="m37.19 74.41c-.29 0-.58-.06-.84-.19-1-.45-1.44-1.63-1-2.63l2.65-5.6c.33-1.05 1.46-1.64 2.51-1.3 1.05.33 1.64 1.46 1.3 2.51-.05.17-.13.34-.23.49l-2.65 5.59c-.32.67-.99 1.1-1.74 1.13z"/><path d="m55.75 61.53c-.29 0-.58-.07-.85-.19-.98-.48-1.4-1.65-.94-2.64l2.65-5.59c.61-.92 1.85-1.17 2.77-.56.74.49 1.07 1.41.81 2.25l-2.69 5.6c-.33.67-1 1.11-1.75 1.13z"/><path d="m49.65 74.41c-.29 0-.58-.06-.84-.19-.98-.47-1.4-1.64-.95-2.63l2.64-5.59c.33-1.05 1.46-1.64 2.51-1.3 1.05.33 1.64 1.46 1.3 2.51-.05.17-.13.34-.23.49l-2.65 5.59c-.33.68-1.02 1.11-1.78 1.12z"/><path d="m65.89 55.85c-1.1 0-2-.9-2-2s.9-2 2-2c4.48-.03 8.09-3.68 8.06-8.16-.02-3.95-2.89-7.3-6.78-7.95-.52-.08-.99-.37-1.3-.8s-.44-.97-.35-1.49c.88-4.89-2.38-9.57-7.27-10.45-.54-.1-1.09-.14-1.64-.14-1.94 0-3.83.63-5.39 1.79-.85.62-2.03.48-2.71-.33-4.61-5.62-12.91-6.43-18.54-1.82-2.91 2.39-4.66 5.9-4.8 9.66-.05.94-.74 1.71-1.66 1.87-4.87.97-8.03 5.72-7.06 10.59.82 4.09 4.35 7.09 8.52 7.23 1.1 0 2 .9 2 2s-.9 2-2 2c-7.14 0-12.93-5.79-12.93-12.93 0-5.74 3.79-10.8 9.3-12.41 1.22-9.38 9.82-16 19.2-14.78 3.7.48 7.14 2.16 9.8 4.78 1.91-1.05 4.05-1.61 6.23-1.6 7.18 0 13 5.82 13 13v.35c6.34 2.06 9.81 8.87 7.75 15.21-1.61 4.97-6.25 8.34-11.47 8.34z"/></g></svg>',
    //мокрый снег
    '69': '<svg id="Layer_1" enable-background="new 0 0 90 90" viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg"><g fill="rgb(0,0,0)"><path d="m52.29 63.19c-1.05 0-1.91-.86-1.91-1.91v-17.29c-.08-1.05.71-1.97 1.77-2.04s1.97.71 2.04 1.77c.01.09.01.18 0 .28v17.32c-.02 1.03-.86 1.87-1.9 1.87z"/><path d="m44.79 58.86c-1.05.02-1.93-.82-1.95-1.87-.01-.69.35-1.34.95-1.69l15-8.66c.88-.58 2.06-.34 2.65.54.58.88.34 2.06-.54 2.65-.06.04-.13.08-.2.12l-15 8.66c-.28.16-.59.24-.91.25z"/><path d="m59.79 58.86c-.35 0-.7-.09-1-.26l-15-8.66c-.88-.58-1.12-1.77-.54-2.65.53-.8 1.58-1.08 2.45-.65l15 8.66c.91.53 1.22 1.69.7 2.6-.33.58-.94.94-1.61.96z"/><path d="m31.95 75.51c-1.05.01-1.9-.84-1.91-1.89v-.01-13.72c.08-1.05.99-1.84 2.04-1.77.95.07 1.7.82 1.77 1.77v13.72c0 1.05-.85 1.9-1.9 1.9z"/><path d="m26.01 72.08c-1.05.03-1.93-.79-1.96-1.84-.02-.7.35-1.36.96-1.71l11.88-6.86c.94-.47 2.09-.09 2.56.85.43.86.15 1.91-.65 2.45l-11.88 6.86c-.28.16-.59.25-.91.25z"/><path d="m37.88 72.08c-.33 0-.66-.09-.95-.25l-11.88-6.84c-.88-.58-1.12-1.77-.54-2.65.53-.8 1.58-1.08 2.45-.65l11.88 6.86c.91.52 1.23 1.68.71 2.59-.35.61-1.01.98-1.71.96z"/><path d="m65.9 54.74c-1.1 0-2-.9-2-2s.9-2 2-2c4.48-.03 8.08-3.69 8.05-8.17-.03-3.94-2.89-7.29-6.78-7.94-.52-.08-.99-.37-1.3-.8s-.44-.97-.35-1.49c.88-4.89-2.38-9.57-7.27-10.45-.54-.1-1.09-.14-1.64-.14-1.94 0-3.83.63-5.39 1.79-.85.62-2.03.48-2.71-.33-4.61-5.62-12.91-6.44-18.54-1.82-2.91 2.39-4.66 5.9-4.8 9.66-.02.96-.72 1.78-1.67 1.94-4.87.97-8.03 5.72-7.06 10.59.82 4.09 4.35 7.09 8.52 7.23h13.22c1.1 0 2 .9 2 2s-.9 2-2 2h-13.21c-7.14 0-12.93-5.79-12.93-12.93 0-5.74 3.79-10.8 9.3-12.41 1.22-9.38 9.82-16 19.2-14.78 3.7.48 7.14 2.16 9.8 4.78 1.91-1.05 4.05-1.61 6.23-1.6 7.18 0 13 5.82 13 13v.35c6.34 2.06 9.81 8.87 7.75 15.21-1.61 4.97-6.24 8.33-11.46 8.34z"/></g></svg>',
    //снег
    '70': '<svg id="Layer_1" enable-background="new 0 0 90 90" viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg"><g fill="rgb(0,0,0)"><path d="m52.29 63.19c-1.05 0-1.91-.86-1.91-1.91v-17.29c-.08-1.05.71-1.97 1.77-2.04s1.97.71 2.04 1.77c.01.09.01.18 0 .28v17.32c-.02 1.03-.86 1.87-1.9 1.87z"/><path d="m44.79 58.86c-1.05.02-1.93-.82-1.95-1.87-.01-.69.35-1.34.95-1.69l15-8.66c.88-.58 2.06-.34 2.65.54.58.88.34 2.06-.54 2.65-.06.04-.13.08-.2.12l-15 8.66c-.28.16-.59.24-.91.25z"/><path d="m59.79 58.86c-.35 0-.7-.09-1-.26l-15-8.66c-.88-.58-1.12-1.77-.54-2.65.53-.8 1.58-1.08 2.45-.65l15 8.66c.91.53 1.22 1.69.7 2.6-.33.58-.94.94-1.61.96z"/><path d="m31.95 75.51c-1.05.01-1.9-.84-1.91-1.89v-.01-13.72c.08-1.05.99-1.84 2.04-1.77.95.07 1.7.82 1.77 1.77v13.72c0 1.05-.85 1.9-1.9 1.9z"/><path d="m26.01 72.08c-1.05.03-1.93-.79-1.96-1.84-.02-.7.35-1.36.96-1.71l11.88-6.86c.94-.47 2.09-.09 2.56.85.43.86.15 1.91-.65 2.45l-11.88 6.86c-.28.16-.59.25-.91.25z"/><path d="m37.88 72.08c-.33 0-.66-.09-.95-.25l-11.88-6.84c-.88-.58-1.12-1.77-.54-2.65.53-.8 1.58-1.08 2.45-.65l11.88 6.86c.91.52 1.23 1.68.71 2.59-.35.61-1.01.98-1.71.96z"/><path d="m65.9 54.74c-1.1 0-2-.9-2-2s.9-2 2-2c4.48-.03 8.08-3.69 8.05-8.17-.03-3.94-2.89-7.29-6.78-7.94-.52-.08-.99-.37-1.3-.8s-.44-.97-.35-1.49c.88-4.89-2.38-9.57-7.27-10.45-.54-.1-1.09-.14-1.64-.14-1.94 0-3.83.63-5.39 1.79-.85.62-2.03.48-2.71-.33-4.61-5.62-12.91-6.44-18.54-1.82-2.91 2.39-4.66 5.9-4.8 9.66-.02.96-.72 1.78-1.67 1.94-4.87.97-8.03 5.72-7.06 10.59.82 4.09 4.35 7.09 8.52 7.23h13.22c1.1 0 2 .9 2 2s-.9 2-2 2h-13.21c-7.14 0-12.93-5.79-12.93-12.93 0-5.74 3.79-10.8 9.3-12.41 1.22-9.38 9.82-16 19.2-14.78 3.7.48 7.14 2.16 9.8 4.78 1.91-1.05 4.05-1.61 6.23-1.6 7.18 0 13 5.82 13 13v.35c6.34 2.06 9.81 8.87 7.75 15.21-1.61 4.97-6.24 8.33-11.46 8.34z"/></g></svg>',
    //град
    '90': '<svg id="Layer_1" enable-background="new 0 0 90 90" viewBox="0 0 90 90" xmlns="http://www.w3.org/2000/svg"><g fill="rgb(0,0,0)"><path d="m26.13 74.86c-1.44 0-2.7-.96-3.09-2.34l-.08-.27c-.42-1.73.64-3.47 2.37-3.89 1.64-.4 3.3.53 3.82 2.13l.08.28c.5 1.71-.48 3.49-2.19 3.99-.01 0-.02.01-.03.01-.29.07-.58.1-.88.09z"/><path d="m28.91 66.08c-1.05 0-1.91-.86-1.9-1.92 0-.28.06-.56.18-.82l5.07-10.51c.46-.95 1.59-1.35 2.54-.89s1.35 1.59.89 2.54l-5.06 10.5c-.32.68-.98 1.1-1.72 1.1z"/><path d="m38.59 74.86c-1.44 0-2.7-.96-3.09-2.34l-.08-.27c-.42-1.73.64-3.47 2.37-3.89 1.64-.4 3.3.53 3.82 2.13l.08.28c.5 1.71-.48 3.49-2.19 3.99-.01 0-.02.01-.03.01-.29.07-.58.1-.88.09z"/><path d="m41.37 66.08c-1.05 0-1.91-.86-1.9-1.92 0-.28.06-.56.18-.82l5.07-10.51c.46-.95 1.59-1.35 2.54-.89s1.35 1.59.89 2.54l-5.06 10.5c-.32.68-.98 1.1-1.72 1.1z"/><path d="m51.11 74.76c-.98 0-1.91-.44-2.52-1.21l-.13-.16c-.96-1.5-.52-3.49.98-4.45 1.28-.81 2.95-.63 4.02.45l.13.17c1.11 1.38.89 3.4-.49 4.51-.57.46-1.28.71-2.02.71z"/><path d="m53.83 66.08c-1.05 0-1.91-.86-1.9-1.92 0-.28.06-.56.18-.82l5.07-10.51c.46-.95 1.59-1.35 2.54-.89s1.35 1.59.89 2.54l-5.06 10.5c-.32.68-.98 1.1-1.72 1.1z"/><path d="m65.9 55.39c-1.1 0-2-.9-2-2s.9-2 2-2c4.48-.03 8.08-3.69 8.05-8.17-.03-3.94-2.89-7.29-6.78-7.94-1.09-.17-1.84-1.19-1.67-2.28v-.01c.08-.51.13-1.02.13-1.54-.01-5-4.05-9.04-9.05-9.05-1.94 0-3.83.63-5.39 1.79-.85.62-2.03.48-2.71-.33-4.61-5.62-12.91-6.44-18.54-1.83-2.91 2.39-4.65 5.9-4.8 9.66-.04.94-.73 1.72-1.66 1.88-4.87.97-8.03 5.72-7.06 10.59.82 4.09 4.35 7.09 8.52 7.23 1.1 0 2 .9 2 2s-.9 2-2 2c-7.14 0-12.93-5.79-12.93-12.93 0-5.74 3.79-10.8 9.3-12.41 1.23-9.39 9.84-15.99 19.23-14.76 3.69.48 7.12 2.16 9.77 4.76 6.3-3.45 14.2-1.13 17.64 5.16 1.05 1.92 1.6 4.07 1.6 6.26v.35c6.34 2.06 9.81 8.87 7.75 15.21-1.61 4.97-6.24 8.33-11.46 8.34z"/></g></svg>'
}

//для графика PolarChart
export const polarChartPrepareData = ( data, source, settings, unit ) => {

     const getLimitIndex = ( limits, value ) => {
        let index = 0;
        for (let i in limits) {
            if ( limits[i] < value )
                ++index;
            else
                break;
        }
        return index;
    };

    const correctDatasets = ( correctData ) => {        
        for (let rumb = 0; rumb < settings.polar_labels.length; rumb++) {
            let prevValue = 0;
            for (let i in correctData) {
                if (correctData[i].data[rumb] > 0) {
                    correctData[i].data[rumb] += prevValue;
                    prevValue = correctData[i].data[rumb];
                }
            }
        }
        return correctData;
    }

    const convertToPercent = ( data, totalValues ) => {       
        return data.map( speedItem => {
            let data = speedItem.data.map( directItem => directItem * 100 / totalValues )
            speedItem.data = data;
            return speedItem;
        })
    }

    let datasets = [];

    for ( let i in settings.limits) {

        let item = {
            "label": (i > 0 ? settings.limits[i -1] +'-'+ settings.limits[i] : '<' + settings.limits[i]) + unit,
            "data": new Array(settings.polar_labels.length).fill(0),
            "backgroundColor": settings.limits_colors[i],
            fill: true,
            borderColor: 'rgba(255, 255, 255, 0.5)',
            borderWidth: 1,
            order: i

        };
        datasets.push(item);
    };

    //для некоторых величин надо задавать величину больше последней (для ветра)
    if (settings.limits.length < settings.limits_colors.length ) {
        let i = settings.limits.length;

        let item = {
            "label": '>' + settings.limits[i-1] + unit,
            "data": new Array(settings.polar_labels.length).fill(0),
            "backgroundColor": settings.limits_colors[i],
            fill: true,
            borderColor: 'rgba(255, 255, 255, 0.5)',
            borderWidth: 1,
            order: i
        }

        datasets.push( item );
    }

    //заполняем данными
    let totalHasData = 0;
    for (let i in data) {
        let direct = source[i][settings.polar_field];
        if (!Number.isInteger(direct))
            continue;
        let rumb = settings.polar_limits_calc( source[i][settings.polar_field] );
        let limitIndex = getLimitIndex(settings.limits, data[i]);
        ++totalHasData;
        ++datasets[limitIndex].data[rumb];
    }    

    //заменяем абсолютные величины на проценты

    //корректируем данные - необходимо, чтоб у самого дальнего значения было максимальное значение
    //чтоб все меньше ложиллсь поверх и все датасеты от "дальних" к "ближнему" (к центру)
    datasets = correctDatasets( datasets );

    ////заменяем абсолютные величины на проценты
    datasets = convertToPercent( datasets, totalHasData );

    return datasets;
}

export function ShowLocaleDateTime( date ) {
    let result = 
        new Date( date ).toLocaleDateString(
            References.locale, {year: 'numeric', month: 'numeric', day: 'numeric'}
        ) + ' ' + 
        new Date( date ).toLocaleTimeString(
            References.locale, {hour: 'numeric', minute: 'numeric'}
        )        
    return result;
}

export function ShowLocaleDate( date ) {
    let result = 
        new Date( date ).toLocaleDateString(
            References.locale, {year: 'numeric', month: 'numeric', day: 'numeric'}
    )    
    return result;    
}

export function GetDecade( currDay ) {
    if ( !currDay )
        currDay = new Date().getDate(); 
    let decade = Math.ceil( currDay / 10);
    return Math.min( 3, decade );
    return decade === 3 ? decade : decade + 1;
}

export function FormatDateByDecade( decade, month, year, isStart ) {
    let day = 1;
    if (isStart) {
        day = (decade - 1) * 10 + 1;
    } else {
        if ( decade == 3 ) {
            day = new Date( year, month + 1, 0 ).getDate();
        } else
            day = decade * 10;
        
    }
    let date = new Date(year, month, day);
    return date;
}

export function FormatDateByMonth( month, year, isStart )  {
    let day = 1;
    if (!isStart) 
        day = new Date( year, month, 0).getDate();
    let date = new Date( year, month - 1, day );
    return date;
}

export function GetStepMonth( currMonth, step ) {
    let stepMonth = currMonth + step;
    if (stepMonth >= 12)
        stepMonth = 0;
    else if (stepMonth < 0)
        stepMonth = 11;
    return stepMonth;
}

export function GetSeason( currDate ) {
    if (!currDate)
        currDate = new Date();

    let month = currDate.getMonth() + 1;
    if ( month >= 3 && month <= 5)
        return 2;   //spring
    else if ( month >= 6 && month <= 8)
        return 3;   //summer
    else if ( month >= 9 && month <= 11 )
        return 4;   //autumn
    else 
        return 1;   //winter    
}

//много поправок на то, что зима берется из прошлого года
export function FormatDateBySeason( season, year, isStart, isFilled ) {
    let day = 1;
    let month = 1;
    switch (season) {
        case 1:
            if (!isStart) {
                day = new Date( year, 2, 0).getDate();
                month = 1;
            } else {
                if (!isFilled)
                    --year;
                day = 1;
                month = 11;                    
            }
        break;
        case 2:
            if (isStart) 
                month = 2;
            else {
                day = 31;
                month = 4;                    
            }
        break;
        case 3:
            if (isStart)
                month = 5;
            else {
                month = 7;
                day = 31;
            }
        break;
        case 4:
            if (isStart)
                month = 8;
            else {
                month = 10;
                day = 30;
            }
        break;
    }
    let date = new Date( year, month, day );
/*    if (!isStart)
        date.setSeconds( 99 );*/
    return date;
}

export function FormatDateByYear( year, isStart ) {
    let day = isStart ? 1 : 31;
    let month = isStart ? 0 :11;
    let date = new Date( year, month, day );
    return date;
}

export function GetStamp() {
    return Date.now();
}

export function IsArraysContains( what, where ) {    
    if (what.length > where) 
        return false;

    for (let i in what ) {
        if (where.indexOf(what[i]) === -1 )
            return false;
    }    
    return true;         
}

export function IsArraysHas( what, where ) {
    for ( let i in what ) {
        if ( where.indexOf(what[i]) !== -1 )
            return true;
    }
    return false;
}

export function ArrayToggle(arr, item) {
    var idx = arr.indexOf(item);
    if (idx !== -1) {
        arr.splice(idx, 1);
    } else {
        arr.push(item);
    }
    return arr;
  }

export function ArrayNumElementsAmount( arr ) {
    let result = arr.filter(value => Number.isFinite(value));
    return result.length;
}

export function ShowWindDirectInRumb( direct ) {
    let directs = References.mchs['wind'].polar.polar_labels;                    
    let rumb = Math.floor( direct / 22.5 );

    if (directs.hasOwnProperty(rumb))                                
        return directs[rumb];
}

export function ConvertToDatepickerDate( humanDate ) {
    let date = new Date( humanDate );
    return {
        "$y": date.getFullYear(), 
        "$M": date.getMonth(),
        "$D": date.getDate(),
        "$H": date.getHours()
    }
}

export function getBaseLog(x, y) {
    return Math.log(y) / Math.log(x);
}

export function DownloadCSV( data, filename, charset = 'UTF-8', onFinish = null ) {
    let a = document.createElement("a");
    let file = new Blob([data], {type: 'application/csv;charset=' + charset});
    a.href = URL.createObjectURL(file);
    a.download = filename + '.csv';
    a.click();        

    if ( typeof onFinish == 'function')
        onFinish();    
}

export const getMinMaxBySettings = (measurer, settings, values ) => {
    let arr = [];
    settings.forEach(elem => {
        if (measurer.settings && measurer.settings.hasOwnProperty(elem) && Number.isFinite(measurer.settings[elem]))
            arr.push( measurer.settings[elem] );
    })
    return {
        max: Math.max(...arr, ...values),
        min: Math.min(...arr, ...values)
    }    
}

export const isHasNormailzed = ( method, mchsType ) => {
    return method !== 'no' && References.normalizes_methods.hasOwnProperty(method) && References.normalizes_channels.indexOf( mchsType )  !== -1;
}

export const upTo10MinutesRound = ( dateTime ) => {
    const minutes = dateTime.minute();
    const needAdded = 10 - minutes % 10;
    return dateTime.add( needAdded, 'minute');
}

export const downTo10MinutesRound = ( dateTime ) => {
    const minutes = dateTime.minute();
    return dateTime.subtract( minutes % 10, 'minute');
}

export const fromRefByDomain = (keys, subdomainSettings) => {
    const source = subdomainSettings ?? References;        
    const value = keys.reduce((currentValue, key) => {
        return currentValue[key];
    }, source);

    return value;
}

export const clearStationFilters = () => {
    useStationFilter.setState({    
        term: '',
        mchs: {
            items: [],
            orAnd: 'or'
        },
        areas: []
    });
}

export const isVisibleMainMenu = (permission) => {
    return permission?.permissions?.can_view_event_data
}

export const concatArrays = (arr) => {
    return arr.reduce((acc, val) => {
        return acc.concat(val)
    }, [])    
}

export const getDangerShortName = (code) => {
    return References.danger.hasOwnProperty(code) ? References.danger[code].short : References.danger.default.short;
} 

export const getDangerName = (code) => {
    return References.danger.hasOwnProperty(code) ? References.danger[code].name : References.danger.default.name;
} 

export const getDangerColor = (code, stateColors = {}) => {
    if (stateColors.hasOwnProperty(code))
        return stateColors[code];

    if (References.danger.hasOwnProperty(code)) 
        return References.danger[code].color;

    return References.danger.default.color;    
} 

export const getDangerBGColor = (code) => {
    if (code === References.dangers.oya)
        return "rgb(140, 140, 140)";
    if (code === References.dangers.nya)
        return "rgb(110, 110, 110)";    
}

export const isStationHasCamera = ( station ) => {
    return station?.photo && Number.isFinite(station.photo.photo_id)
}

export const getMarkerPopupMaxHeight = (station, defaultHeight) => {
    if (isStationHasCamera(station))
        return defaultHeight - 100;

    return defaultHeight;
}